import * as React from 'react';
import { Route, Switch, withRouter } from "react-router-dom";
import Home from "../../components/home/home";
import AuthService from '../../services/authService';
import { connect } from 'react-redux';
import LoginComponent from '../login/loginComponent';
import UserProfile from '../profile/userProfile';
import SynchronizationComponent from '../synchronization/synchronizationComponent';
import OfferListComponent from '../offers/offerListComponent';
import AddEditOfferComponent from '../offers/addEditOfferComponent';
import NewOfferComponent from '../offers/newOfferComponent';
import SettingsComponent from '../settings/settingsComponent';

const NoMatch = () => (
    <div>
        <h3>
            URL address <code>{window.location.pathname}</code> not match.
    </h3>
    </div>
);

// const NotAuthorizedComponent = () => (
//     <div className="app-content">
//         <h3>{Translate('You are not Authenticated to view this resource')}</h3>
//     </div>)


interface Iprops {
    history: any,
    isUserLogged: boolean;
    lang: string;
}

interface IState {
}

class Navigation extends React.Component<Iprops, IState> {
    authService = new AuthService();


    render() {
        return (
            <>
                <Switch>
                    <Route exact path="/" component={this.authService.isAuthenticated() ? Home : LoginComponent} />
                    <Route exact path="/login" component={this.authService.isAuthenticated() ? Home : LoginComponent} />
                    <Route path="/userprofile" component={this.authService.isAuthenticated() ? UserProfile : LoginComponent} />
                    <Route path="/synchronization" component={this.authService.isAuthenticated() ? SynchronizationComponent : LoginComponent} />
                    <Route exact path="/newoffer" component={this.authService.isAuthenticated() ? NewOfferComponent : LoginComponent} />
                    <Route exact path="/offers" component={this.authService.isAuthenticated() ? OfferListComponent : LoginComponent} />
                    <Route exact path="/offers/:OfferId" component={this.authService.isAuthenticated() ? AddEditOfferComponent : LoginComponent} />
                    <Route exact path="/settings" component={this.authService.isAuthenticated() ? SettingsComponent : LoginComponent} />
                    <Route component={NoMatch} />
                </Switch>
            </>
        )
    }
}

const mapsStateToProps = state => {
    return {
        isUserLogged: state.common.isUserLogged,
        lang: state.common.lang
    };
}


export default withRouter(connect(mapsStateToProps)(Navigation));